import React from 'react';
import Heading from '@legacy-vfuk/core-heading';
import { TitleWrapper } from './styles/FeatureCardsWithIcon.styles';

export type FeatureCardsWithIconTitleProps = {
  title?: string;
};

const FeatureCardsWithIconTitle = ({
  title,
}: FeatureCardsWithIconTitleProps) => {
  return (
    <TitleWrapper>
      <Heading
        text={title}
        level={2}
        size={3}
        appearance={'primary'}
        justify={'center'}
        weight={2}
      />
    </TitleWrapper>
  );
};

export default FeatureCardsWithIconTitle;
